import React, { useState, useEffect, useRef} from 'react';
import axios from 'axios';
import Menu from '../../components/Menu/Menu';
import Modal from 'react-bootstrap/Modal';
import Switch from "react-switch";
import Button from 'react-bootstrap/Button';
import { Radio, Input, Space,message, Divider, Empty, Spin, Modal as AntDModal  } from 'antd';
import { REACT_APP_WORKING_URL, REACT_APP_WORKING_CHATAPI_URL } from '../../Constants'
import './MyDocuments.scss'
import { LeftOutlined } from '@ant-design/icons';
import DocumentsList from '../../components/DocumentsList/DocumentsList';
import { createTheme, deleteTheme, getDocumentListByTheme, getThemeListById } from '../../requests/theme';
import { deleteDocument } from '../../requests';
import ThemeSelector from '../../components/ThemeSelector/ThemeSelector';
const {TextArea} = Input;

const checkIfFileNameExists = (array, searchString) => {
    const userNames = array.map((item) => item.document_name);
    return userNames.indexOf(searchString) !== -1;
};

const checkExistingFiles = (array, fileName) => {
    let index = 1;
    let baseName = fileName;
    let extension = '';
    const dotIndex = fileName.lastIndexOf('.');
    if (dotIndex !== -1) {
        baseName = fileName.substring(0, dotIndex);
        extension = fileName.substring(dotIndex);
    }
    let newFileName = fileName;

    // Loop through the file list to check for similar names
    while (checkIfFileNameExists(array, newFileName)) {
        newFileName = `${baseName}(${index})${extension}`;
        index++;
    }
    return newFileName;
};

const options = [
    {
        label: 'File',
        value: 'File',
    },
    {
        label: 'Url',
        value: 'Url',
    },
    {
        label: 'Img',
        value: 'Img',
    },
    {
        label: 'Text',
        value: 'Text',
    },
    {
        label: 'Question Bank',
        value: 'QuestionBank',
    },
];
const MyDocuments = () => {
    const apiUrl = REACT_APP_WORKING_URL
    const chatApiUrl = REACT_APP_WORKING_CHATAPI_URL

    const [file, setFile] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [imgFile, setImgFile] = useState(null);
    const [uploadedimgFile, setUploadedImgFile] = useState(null);
    const [questionfile, setQuestionFile] = useState(null);
    const [uploadedQuestionFile, setUploadedQuestionFile] = useState(null);
    const [rerender, setRerender] = useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [manageMode, setManageMode] = useState(false);
    const [isPending, setIsPending] = useState(false);
    const [publicSwitch, setPublicSwitch] = useState(false);
    const [radioValue, setRadioValue] = useState('File');
    const [url, setUrl] = useState('');
    const user = JSON.parse(localStorage.getItem('user'));
    const [documentsList, setDocumentsList] = useState([]);
    const [questionBankList, setQuestionBankList] = useState([]);
    const [text, setText] = useState('');
    const [textName, setTextName] = useState('');
    const [messageApi, contextHolder] = message.useMessage();

    const [isEdit, setIsEdit] = useState(false);
    const [theme, setTheme] = useState(null);
    const [isInTheme, setIsInTheme] = useState(false);
    const [inThemeInfo, setInThemeInfo] = useState(null);
    const [themeList, setThemeList] = useState([]);
    const [themeDocumentList,setThemeDocumentList] = useState([]);
    const inputRefs=useRef([]);
    const [spinning, setSpinning] = useState(false);
    const [isAntDModalOpen, setIsAntDModalOpen] = useState(false); 
    const deleteDocListRef = useRef([]);

    useEffect(()=>{
        let bool = themeList.find((ele)=>ele.isEdit === true) 
        if(bool){
            inputRefs.current[0].select();
        }
    }, [themeList])

    useEffect(() => {
        const func = async ()=>{
            const p1 = axios.post(`${apiUrl}document/getFileListById/${user.user_id}`, {}, {
                headers: {
                  authorization: `Bearer ${user.accessToken}`,
                },
            })
            const p2 = axios.post(`${apiUrl}document/getQuestionFileListById/${user.user_id}`, {}, {
                headers: {
                authorization: `Bearer ${user.accessToken}`,
                },
            })

            const p3 = getThemeListById(user.user_id);
            const [res1, res2, res3] = await Promise.all([p1,p2,p3]);
            setDocumentsList(res1.data)
            setQuestionBankList(res2.data);
            // setThemeList(res3.map(ele=>{return {
            //     theme_id: ele.theme_id,
            //     document_name: ele.theme_name,
            //     document_type: 'theme',
            //     isEdit: false
            // }}))
            setThemeList(res3)
        };

        if (user && user.user_id) {
            try{
                func();
            }catch(err){
                alert(err);
            }
        }
    }, [rerender])

    const toggleMenu = (e) => {
        setShowUploadModal(!showUploadModal);
    };

    const handleOpenFile = (item) => {
        window.open(item.document_url, "_blank")
    }

    const handleFileChange = (event) => {
        let sf, suf, dl;
        if(radioValue === 'File'){
            sf = setFile;
            suf = setUploadedFile;
            dl = documentsList;
        }else if(radioValue === 'QuestionBank'){
            sf = setQuestionFile;
            suf = setUploadedQuestionFile;
            dl = questionBankList;
        }else if(radioValue === 'Img'){
            sf = setImgFile;
            suf = setUploadedImgFile;
            dl = documentsList;
        }
        event.preventDefault();
        suf(null)
        try {
            const selectedFile = event.target.files[0];
            if (selectedFile) {
                const exist = checkIfFileNameExists(dl, selectedFile.name);
                if (exist) {

                    sf(selectedFile)
                    suf({
                        document_name: checkExistingFiles(dl, selectedFile.name),
                        document_type: selectedFile.type,
                        document_size: selectedFile.size,
                    })
                }
                else {
                    sf(selectedFile)
                    suf({
                        document_name: checkExistingFiles(dl, selectedFile.name),
                        document_type: selectedFile.type,
                        document_size: selectedFile.size,
                    })
                }
            }
        }
        catch {
            alert('Error!')
        }
    };

    const changeMode = (e) => {
        setManageMode(!manageMode)
    }



    const handleUpload = async (e) => {
        if(!theme){
            message.error({
                content: 'Please select theme',
                
            });
            return;
        }
        if (radioValue === 'File' && !file) {
            message.error({
                content: 'Please select document you want to upload',
                
            });
            return;
        }
        if (radioValue === 'QuestionBank' && !questionfile) {
            message.error({
                content: 'Please select document you want to upload',
                
            });
            return;
        }
        if (radioValue === 'Url' && !url) {
            message.error('Please enter url');
            return;
        }
        if (radioValue === 'Text' && text.length === 0) {
            message.error('Please input text');
            return;
        }

        const formData = new FormData();
        formData.append('theme_id', theme);
        if (radioValue === 'File') {
            setUploadedFile()
            toggleMenu()
            formData.append('file', file);
            formData.append('user_id', user.user_id);
            formData.append('user_name', user.user_name);
            formData.append('access', publicSwitch ? "public" : "private");
            formData.append('theme', theme);
            try {
                setIsPending(true)
                axios.post(`${apiUrl}document/uploadFile`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        uploadUser: user.email,
                        documentType: uploadedFile.document_type,
                        documentName: encodeURIComponent(uploadedFile.document_name),
                        documentSize: uploadedFile.document_size,
                        uploaderId: user.user_id,
                        uploaderName: user.user_name,
                        authorization: `Bearer ${user.accessToken}`,
                    }
                })
                    .then((res) => {
                        formData.append('document_id', res.data.insertId);
                        formData.append('document_name', uploadedFile.document_name);
                        axios.post(`${chatApiUrl}processTextView/`, formData, {
                            headers: {
                                authorization: `Bearer ${user.accessToken}`,
                            },
                        })
                        .then(res => {
                            alert("Upload Complete!")
                            setIsPending(false)
                            window.location.reload();
                        })
                        .catch(err => {
                            alert(err)
                            setIsPending(false)
                            window.location.reload();
                        })
                    });
            } catch (error) {
                console.log('here error');

                console.log(error)
                alert('Upload failed: ', error);
                setIsPending(false)
            }
        }

        if(radioValue === 'QuestionBank'){
            formData.append('file', questionfile);
            formData.append('user_id', user.user_id);
            formData.append('user_name', user.user_name);
            formData.append('access', publicSwitch ? "public" : "private");
            formData.append('theme', theme);
            // formData.append('documentType', uploadedQuestionFile.document_type);
            // formData.append('documentName', encodeURIComponent(uploadedQuestionFile.document_name));
            // formData.append('documentSize', uploadedQuestionFile.document_size);
            // formData.append('uploaderId', user.user_id);
            // formData.append('uploaderName', user.user_name);
            // formData.append('authorization', `Bearer ${user.accessToken}`);
            // formData.append('uploadUser', user.email);
            try {
                setIsPending(true)
                const res = await axios.post(`${apiUrl}document/uploadQuesBankFile/`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        uploaduser: user.email,
                        documenttype: uploadedQuestionFile.document_type,
                        documentname: encodeURIComponent(uploadedQuestionFile.document_name),
                        documentsize: uploadedQuestionFile.document_size,
                        uploaderid: user.user_id,
                        uploadername: user.user_name,
                        authorization: `Bearer ${user.accessToken}`,
                    }
                })
                setUploadedQuestionFile()
                toggleMenu()
                setIsPending(false)
                const {insertId} = res.data;
                
                const fd2 = new FormData();
                fd2.append('user_id', user.user_id);
                fd2.append('document_id', insertId);
                setIsPending(false)
                messageApi.info('Analyzing the file... go quiz practice to check result.');
                axios.post(`${chatApiUrl}import_quiz/`, fd2, {
                    headers: {
                        authorization: `Bearer ${user.accessToken}`,
                    },
                })
                await messageApi.open({
                    type: 'info',
                    content: 'Reloading in 2s...',
                    duration: 1,
                });
                await messageApi.open({
                    type: 'info',
                    content: 'Reloading in 1s...',
                    duration: 1,
                });
                // alert("Upload Complete!")
                // setIsPending(false)
                // setTimeout(() => {
                window.location.reload();
                // }, 1000);
            } catch (error) {
                console.log(error)
                alert('Upload failed: ', error);
                setIsPending(false)
            }
        }

        if (radioValue === 'Url') {
            setUploadedFile()
            toggleMenu()
            let urlObejct;
            try {
                urlObejct = new URL(url);
            } catch (err) {
                alert('Invalid url.');
                return;
            }
            debugger;

            const data = {
                'url': url,
                'user_id': user.user_id,
                'user_name': user.user_name,
                'uploadEmail': user.email,
                'documentType': 'url',
                'document_name': urlObejct.hostname,
                'access': publicSwitch ? "public" : "private",
                'theme_id': theme,
            }
            console.log('data', data)
            try {
                setIsPending(true)
                const {htmlRes, insertId} = await axios.post(`${apiUrl}document/uploadUrl`, data, {
                    headers: {
                        authorization: `Bearer ${user.accessToken}`,
                    },
                })
                setIsPending(false)
                // data['document_id'] = res.data.insertId;
                // console.log('res', res)
                // const aiRes = await axios.post(`${chatApiUrl}webToText/`, formData)
                alert("Upload Complete!")
                const newWindow = window.open('', '_blank');
                newWindow.document.write(htmlRes);
                newWindow.document.close();
                // window.location.reload();
            } catch (error) {
                console.log('here error');

                console.log(error)
                alert('Upload failed: ', error);
                setIsPending(false)
            }

        }
        
        if(radioValue === 'Text'){
            setUploadedFile()
            toggleMenu()
            const data = {
                'user_id': user.user_id,
                'username': user.user_name,
                'document_name': textName,
                'documentType': 'text/plain',
                'access': publicSwitch ? "public" : "private",
                'content': text,
                'theme_id': theme,
            }
            try {
                setIsPending(true)
                const res = await axios.post(`${apiUrl}document/uploadText`, data, {
                    headers: {
                        authorization: `Bearer ${user.accessToken}`,
                    },
                })
                setIsPending(false)
                // data['document_id'] = res.data.insertId;
                // console.log('res', res)
                // const aiRes = await axios.post(`${chatApiUrl}webToText/`, formData)
                alert("Upload Complete!")
                window.location.reload();
            } catch (error) {
                console.log('here error');
                console.log(error)
                alert('Upload failed: ', error);
                setIsPending(false)
            }
        }
    };

    const handleFilesUI = (file) => {
        if (file.picture) {
            return { withImg: true, uri: file.picture }
        }
        else {
            if (file.document_type == 'pdf' || file.document_type == "application/pdf") {
                return { withImg: false, uri: require('../../assets/images/PDF_file_icon.png') }
            }
            else if (file.document_type == 'word' || file.document_type == "application/msword" || file.document_type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
                return { withImg: false, uri: require('../../assets/images/word.png') }
            }
            else if (file.document_type == 'image' || file.document_type == "image/png" || file.document_type == 'image/jpg' || file.document_type == 'image/jpeg') {
                return { withImg: false, uri: require('../../assets/images/image_icon.png') }
            }
            else if (file.document_type == 'excel' || file.document_type == "application/vnd.ms-excel" || file.document_type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                return { withImg: false, uri: require('../../assets/images/Microsoft_Office_Excel.png') }
            }
            else if (file.document_type == 'ppt' || file.document_type == "application/vnd.ms-powerpoint" || file.document_type == "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
                return { withImg: false, uri: require('../../assets/images/ppt.png') }
            }
            else if (file.document_type == 'text/plain' || file.document_type == "text") {
                return { withImg: false, uri: require('../../assets/images/txt.png') }
            }
            else if (file.document_type == 'url') {
                return { withImg: false, uri: require('../../assets/images/link.png') }
            }
            else if (file.document_type == 'theme'){
                return {withImg: false, uri: require('../../assets/images/folder.png')}
            }
            else {
                return { withImg: false, uri: require('../../assets/images/unknown-file.png') }
            }
        }
    }

    const handleDelete = async (doc) => {
        // console.log('doc', doc);
        const formData = new FormData();
        formData.append('document_id', doc.document_id);
        const res = await axios.post(`${chatApiUrl}document_delete/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                authorization: `Bearer ${user.accessToken}`,
            }
        })
        // const res = await axios.post(`${apiUrl}document/deleteFileById`, {document_id: doc.document_id})
        setRerender(!rerender);
    }

    const radioOnchange = ({ target: { value } }) => {
        setRadioValue(value);
    }

    const urlOnchange = ({ target: { value } }) => {
        setUrl(value);
    }

    // const handleCreateThemeClick = ()=>{
    //     let tempList = themeList.slice();
    //     let tempName = 'New Theme';
    //     const hasRenameDuplicateFileName = (list, name)=>{
    //         for(let i = 0; i < list.length; i++){
    //             const ele = list[i];
    //             if(ele.document_name === name){
    //                 return true;
    //             }
    //         }
    //         return false;
    //     }
    //     let exist = hasRenameDuplicateFileName(themeList, tempName);
    //     if(exist){
    //         const nameList = themeList.map(ele=>ele.document_name);
    //         let i = 2;
    //         while(exist){
    //             let n = tempName + ` (${i})`;
    //            if(nameList.indexOf(n) === -1){
    //                 exist = false;
    //                 tempName = n;
    //            }
    //            i++;
    //         }
    //     }

    //     tempList.unshift({
    //         document_name: tempName,
    //         document_type: 'theme',
    //         isEdit: true
    //     })
    //     setThemeList(tempList);
    // }

    // const handleThemeNameBlur = async (e, index)=>{
    //     let exist;
    //     const tempName = e.target.value;
    //     for(let i = 0; i < themeList.length; i++){
    //         const ele = themeList[i];
    //         if(i === index){
    //             continue;
    //         }
    //         if(ele.document_name === e.target.value){
    //             exist = true;
    //         }
    //     }
    //     if(exist){
    //         messageApi.error('Duplicate filename');
    //     }else{
    //         try{
    //             const {theme_id} = await createTheme({
    //                 user_id: user.user_id,
    //                 theme_name: tempName,
    //             });

    //             const tempList = themeList.slice();
    //             tempList[index] = {...tempList[index], document_name: tempName, theme_id: theme_id, isEdit: false};
    //             setThemeList(tempList);
    //         }catch(err){
    //             console.log(err);
    //             messageApi.error(err.message);
    //         }
    //     }
    // }

    const handleOpenTheme = async(item)=>{
        setSpinning(true);
        const themeDocList = await getDocumentListByTheme(item.theme_id);
        setSpinning(false);
        setIsInTheme(true);
        setInThemeInfo(item);
        setTheme(item.theme_id);
        setThemeDocumentList(themeDocList);
    }

    const handleThemeDelete = async (item, index)=>{
        try{
            const themeDocList = await getDocumentListByTheme(item.theme_id);
            if(themeDocList.length === 0){
                await  deleteTheme(item.theme_id);
                const tempList = themeList.slice();
                tempList.splice(index,1);
                setThemeList(tempList);
            }else{
                deleteDocListRef.current = {theme_id: item.theme_id, themeDocList: themeDocList};
                setIsAntDModalOpen(true);
            }

        }catch(err){
            console.log(err);
            messageApi.error(err.message);
        }
    }

    const handleCancel = () => {
        deleteDocListRef.current = {};
        setIsAntDModalOpen(false);
      };

    const handleOk = async ()=>{
        setIsAntDModalOpen(false);
        let plist = [];
        plist = deleteDocListRef.current.themeDocList && (deleteDocListRef.current.themeDocList.map(ele=> {
            const formData = new FormData();
            formData.append('document_id', ele.document_id);
            deleteDocument(formData);
        }));
        await Promise.all(plist);
        await deleteTheme(deleteDocListRef.current.theme_id)
        setRerender(!rerender);
    }

    const onThemeChange = (value)=>{
        setTheme(value);
    }

    const renderUploadType = (type)=>{
        switch(type){
            case 'File':{
                            return <div style={{minHeight: '50vh'}}>
                                <h1 className='upload-modal-title'>Documents Upload</h1>
                                <ThemeSelector key={inThemeInfo?.theme_id} options={themeList} showAddItem={true} themeDisabled={!!inThemeInfo} theme={theme} onThemeChange={onThemeChange}/>
                                <br/>
                                <br/>
                                {
                                    uploadedFile
                                        ?
                                        <div className='upload-sample-area container d-flex flex-column justify-content-center align-items-center p-2'>
                                            <img style={{ maxWidth: "80px", maxHeight: "80px" }} src={handleFilesUI(uploadedFile).uri} alt="" />
                                            <h3 className='p-0 m-0'>{uploadedFile.document_name}</h3>
                                        </div>
                                        :
                                        <div className='upload-sample-area container'>No File</div>
                                }
                                <div className='w-100 mt-4 d-flex align-items-center'>
                                    <Switch onChange={(e) => {
                                        setPublicSwitch(!publicSwitch
                                        )
                                    }} checked={publicSwitch} />
                                    <div className='upload-switch-comment'>
                                        {publicSwitch ? "Public" : "Private"}
                                    </div>
                                </div>
                                <div className='d-flex flex-column justify-content-center align-items-center'>
                                    <input
                                        type="file"
                                        id="docInput"
                                        accept=".pdf,.doc,.docx,.png,.jpg,.xls"
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                    />
                                    <label htmlFor="docInput" className="mydoc-modal-upload d-flex justify-content-center align-items-center">
                                        Select My File
                                    </label>
                                    <button className='mydoc-modal-save ' onClick={handleUpload}>Upload</button>
                                </div>
                            </div>
            }
            case 'Url':{
                return <div style={{minHeight: '50vh'}}>
                    <h1 className='upload-modal-title'>Enter URL</h1>
                    <ThemeSelector key={inThemeInfo?.theme_id} options={themeList} showAddItem={true} themeDisabled={!!inThemeInfo} theme={theme} onThemeChange={onThemeChange}/>
                                <Input value={url} onChange={urlOnchange} />
                                <div className='upload-switch-container w-100 mt-4 d-flex align-items-center'>
                                    <Switch onChange={(e) => {
                                        setPublicSwitch(!publicSwitch
                                        )
                                    }} checked={publicSwitch} />
                                    <div className='upload-switch-comment'>
                                        {publicSwitch ? "Public" : "Private"}
                                    </div>
                                </div>
                                <div className='d-flex flex-column justify-content-center align-items-center'>
                                    <button className='mydoc-modal-save' onClick={handleUpload}>Upload</button>
                                </div>

                            </div>
            }
            case 'Img':{
                return <div style={{minHeight: '50vh'}}>
                    <ThemeSelector key={inThemeInfo?.theme_id} options={themeList} showAddItem={true} themeDisabled={!!inThemeInfo} theme={theme} onThemeChange={onThemeChange}/>
                    <input type="file" accept="image/*" onChange={(v)=>{alert('change v', v)}}/>
                </div>
            }
            case 'Text':{
                return <div style={{minHeight: '50vh'}}>
                    <h1 className='upload-modal-title'>Input Text</h1>
                    <ThemeSelector key={inThemeInfo?.theme_id} options={themeList} showAddItem={true} themeDisabled={!!inThemeInfo} theme={theme} onThemeChange={onThemeChange}/>
                    <Space style={{ display: 'flex' }}>
                        <span>Name </span>
                        <Input value={textName} onChange={(e)=>{setTextName(e.target.value)}}/>
                    </Space>
                    <div style={{height: '5px'}}></div>
                    <span>Content </span>
                    <TextArea value={text} size='large' onChange={(e)=>setText(e.target.value)} style={{height: '55%'}}/>
                    {/* <Input value={url} onChange={urlOnchange} />
                    <div className='w-100 mt-4 mb-4 d-flex align-items-center'>
                        <Switch onChange={(e) => {
                            setPublicSwitch(!publicSwitch
                            )
                        }} checked={publicSwitch} />
                        <div className='upload-switch-comment'>
                            {publicSwitch ? "Public" : "Private"}
                        </div>
                    </div> */}
                    <div className='upload-switch-container w-100 mt-4 d-flex align-items-center'>
                        <Switch onChange={(e) => {
                            setPublicSwitch(!publicSwitch
                            )
                        }} checked={publicSwitch} />
                        <div className='upload-switch-comment'>
                            {publicSwitch ? "Public" : "Private"}
                        </div>
                    </div>
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        <button className='mydoc-modal-save' onClick={handleUpload}>Upload</button>
                    </div>

                </div>
            }
            case 'QuestionBank':{
                return <div style={{minHeight: '50vh'}}>
                    <h1 className='upload-modal-title'>Question Bank Upload</h1>
                    <ThemeSelector key={inThemeInfo?.theme_id} options={themeList} showAddItem={true} themeDisabled={!!inThemeInfo} theme={theme} onThemeChange={onThemeChange}/>
                    {
                        uploadedQuestionFile
                            ?
                            <div className='upload-sample-area container d-flex flex-column justify-content-center align-items-center p-2'>
                                <img style={{ maxWidth: "80px", maxHeight: "80px" }} src={handleFilesUI(uploadedQuestionFile).uri} alt="" />
                                <h3 className='p-0 m-0'>{uploadedQuestionFile.document_name}</h3>
                            </div>
                            :
                            <div className='upload-sample-area container'>No File</div>
                    }
                    <div className='w-100 mt-4 d-flex align-items-center'>
                        <Switch onChange={(e) => {}} checked={false} disabled/>
                        <div className='upload-switch-comment'>
                            {"Private"}
                        </div>
                    </div>
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        <input
                            type="file"
                            id="docInput"
                            accept=".pdf,.doc,.docx,.png,.jpg,.xls"
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />
                        <label htmlFor="docInput" className="mydoc-modal-upload d-flex justify-content-center align-items-center">
                            Select My File
                        </label>
                        <button className='mydoc-modal-save ' onClick={handleUpload}>Upload</button>
                    </div>
                </div>
            }
        }
    }

    return (
        <div className='my-menu-container'>
            {contextHolder}
            <div className='container mt-5 d-flex justify-content-between'>
                <Menu />
                {
                isInTheme ?
                    <Space size='large'>
                        <LeftOutlined onClick={()=>{setIsInTheme(false); setInThemeInfo(null); setTheme(null)}} style={{transform: 'scale(2)'}}/>
                        <span style={{fontSize: '24px'}}>{inThemeInfo.themeName}</span>
                    </Space> : null
                }
                <div className='d-flex align-items-center mydoc-title'>MY DOCUMENTS</div>
            </div>
            <div className='container d-flex justify-content-end'>
                <Button className='mydoc-mode' onClick={changeMode}>{manageMode ? "Change to Reading Mode" : "Change to Manage Mode"}</Button>
            </div>
            {/* <div className='container justify-content-start'>
                <h3 className='fw-bold'>File</h3>
            </div> */}
            <div className='my-masking-layer'>
                <div className='my-content-container'>
                    <div className='mydoc-shelf container d-flex justify-content-start align-items-center flex-wrap'>
                        {!isInTheme && themeList.map((item, index)=>{ 
                            const url = {withImg: false, uri: require('../../assets/images/folder.png')};
                            return (
                                <button key={item.theme_name + '' + index} className='mydoc-shelf-files col-lg-3 col-md-4 col-sm-6'>
                                    <img className='mydoc-shelf-files-img' src={url.uri} alt="" onClick={() => { handleOpenTheme(item) }} />
                                    {/* {item.isEdit ? <Input ref={(input)=>{inputRefs.current[index] = input}} className='mydoc-shelf-files-title' defaultValue={item.document_name} maxLength={30} onBlur={(e)=>handleThemeNameBlur(e, index)}/> :  */}
                                        <div className='mydoc-shelf-files-title'>{item.theme_name}</div>
                                    {/* } */}
                                    <div className='mydoc-shelf-delete-button'>
                                        <img style={{ display: manageMode ? "block" : "none" }} className='w-100 h-100' src={require('../../assets/images/close.png')} alt="" onClick={() => handleThemeDelete(item, index)} />
                                    </div>
                                </button>
                            );
                        })}
                        {/* {!isInTheme && (documentsList && documentsList.length > 0 ?
                            // <div className='d-flex container w-100 row'>
                                // {
                                    documentsList.map((item, index) => {
                                        const url = handleFilesUI(item)
                                        return (
                                            <button key={index} className='mydoc-shelf-files col-lg-3 col-md-4 col-sm-6'>
                                                <img className='mydoc-shelf-files-img' src={url.uri} alt="" onClick={() => { handleOpenFile(item) }} />
                                                <div className='mydoc-shelf-files-title'>{item.document_name}</div>
                                                <div className='mydoc-shelf-delete-button'>
                                                    <img style={{ display: manageMode ? "block" : "none" }} className='w-100 h-100' src={require('../../assets/images/close.png')} alt="" onClick={() => handleDelete(item)} />
                                                </div>
                                            </button>
                                        )
                                    })
                                // }
                            // </div>
                            :
                            <div className='container d-flex justify-content-center align-items-center'>
                                <Empty 
                                    description={<span>No files available</span>}
                                />
                            </div>
                        )} */}
                        {isInTheme && <DocumentsList documentsList={themeDocumentList} handleClickFile={handleOpenFile} manageMode={manageMode}/>}
                    </div>
                    {/* <div className='container justify-content-start'>
                        <Divider/>
                        <h3 className='fw-bold'>Question Bank File</h3>
                    </div>

                    <div className='mydoc-shelf container d-flex justify-content-start align-items-center'>
                        {questionBankList && questionBankList.length > 0 ?
                            <div className='d-flex container w-100 row'>
                                {
                                    questionBankList.map((item, index) => {
                                        const url = handleFilesUI(item)
                                        return (
                                            <button key={index} className='mydoc-shelf-files col-lg-3 col-md-4 col-sm-6'>
                                                <img className='mydoc-shelf-files-img' src={url.uri} alt="" onClick={() => { handleOpenFile(item) }} />
                                                <div className='mydoc-shelf-files-title'>{item.document_name}</div>
                                                <div className='mydoc-shelf-delete-button'>
                                                    <img style={{ display: manageMode ? "block" : "none" }} className='w-100 h-100' src={require('../../assets/images/close.png')} alt="" onClick={() => handleDelete(item)} />
                                                </div>
                                            </button>
                                        )
                                    })
                                }
                                <div style={{height: '50px'}}></div>
                            </div>
                            :
                            <div className='container d-flex justify-content-center align-items-center'>
                                <Empty 
                                    description={<span>No files available</span>}
                                />
                            </div>

                        }
                    </div> */}
                    <Button className='mydoc-upload' onClick={toggleMenu}>
                        Upload
                    </Button>
                </div>

            </div>
            <AntDModal open={showUploadModal} footer={[]} onCancel={toggleMenu} centered className='upload-file-modal'>
                <Radio.Group
                    options={options}
                    onChange={radioOnchange}
                    value={radioValue}
                    optionType="button"
                    buttonStyle="solid"
                />
                <div className='d-flex justify-content-between flex-column position-relative upload-content' style={{ height: '95%' }}>
                    {renderUploadType(radioValue)}
                </div>
            </AntDModal>
            {/* <Modal id="upload-modal" show={showUploadModal} onHide={toggleMenu} centered dialogClassName="menu-modal left-aligned-modal">
                <Modal.Body className='p-4'>
                    <Radio.Group
                        options={options}
                        onChange={radioOnchange}
                        value={radioValue}
                        optionType="button"
                        buttonStyle="solid"
                    />
                    <div className='d-flex justify-content-between flex-column position-relative upload-content' style={{ height: '95%' }}>
                        {renderUploadType(radioValue)}

                    </div>
                </Modal.Body>
            </Modal> */}

            <Modal id="upload-modal" show={isPending} onHide={isPending} centered dialogClassName="menu-modal left-aligned-modal">
                <Modal.Body className='p-4'>
                    <div className='d-flex justify-content-betweeen align-items-center h-100 flex-column'>
                        <h1 className='upload-modal-title'>Document Uploading</h1>
                        <div className='mt-5 d-flex justify-content-between align-items-center flex-column'>
                            <div className="loader" />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <AntDModal title='Confirm Deletion' open={isAntDModalOpen} onCancel={handleCancel} onOk={handleOk}>
                    <span>You have documents in the theme, are you sure to delete?</span>
            </AntDModal>
            <Spin spinning={spinning} fullscreen/>
        </div>
    );
};

// const mapStateToProps = (state) => (
//     {
//         documentsList: state.documents.documentsList,
//         user: state.auth.user
//     }
// );

// const mapDispatchToProps = {
//     SetDocuments,
//     DeleteDocument
// };

// export default connect(mapStateToProps, mapDispatchToProps)(MyDocuments);
export default (MyDocuments);